import Spec from './SpecTemplate';
import SpecQuery from './SpecQuery.graphql';

Spec.query = SpecQuery;

export default Spec;
